import { useState, useEffect } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = null;
let inflight = null;
const subscribers = new Set();

async function fetchSettings() {
  if (cache) return cache;
  if (inflight) return inflight;
  inflight = fetch(`${API}/settings`)
    .then(r => r.ok ? r.json() : {})
    .then(data => {
      cache = data || {};
      inflight = null;
      subscribers.forEach(cb => cb(cache));
      return cache;
    })
    .catch(() => {
      inflight = null;
      cache = {};
      return cache;
    });
  return inflight;
}

export function invalidateSiteSettings() {
  cache = null;
}

export default function useSiteSettings() {
  const [settings, setSettings] = useState(cache);

  useEffect(() => {
    let mounted = true;
    const cb = (s) => { if (mounted) setSettings(s); };
    subscribers.add(cb);
    if (!cache) {
      fetchSettings().then(cb);
    } else {
      setSettings(cache);
    }
    return () => { mounted = false; subscribers.delete(cb); };
  }, []);

  return settings;
}
